interface UserData {
  permissions: string[];
  role: string;
}

export function hasPermission(permissionKey: string): boolean {
  const userDataString = localStorage.getItem('userData');

  if (!userDataString) {
    console.warn("No userData found in localStorage.");
    return false;
  }
  const userData: UserData = JSON.parse(userDataString);
  if(userData.role === "ROLE_ADMIN") return true;
  return userData.permissions.includes(permissionKey);
}
